import { render, staticRenderFns } from "./STask.vue?vue&type=template&id=6ea7f6d0&scoped=true&"
import script from "./STask.vue?vue&type=script&lang=js&"
export * from "./STask.vue?vue&type=script&lang=js&"
import style0 from "./STask.vue?vue&type=style&index=0&id=6ea7f6d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea7f6d0",
  null
  
)

export default component.exports